import React from "react";

export default function WhiteBackgroundHeartSvg(props: any) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={24} height={24} rx={12} fill="white" />
      <path
        d="M14.6345 8C13.6325 8 12.7612 8.4494 12.2487 9.20252C11.7362 8.4494 10.865 8 9.86293 8C9.10391 8.00088 8.37622 8.30115 7.83951 8.83494C7.3028 9.36872 7.00088 10.0924 7 10.8473C7 12.233 7.86842 13.6752 9.58141 15.133C10.3664 15.7983 11.2142 16.3863 12.1132 16.8889C12.1549 16.9112 12.2014 16.9228 12.2487 16.9228C12.296 16.9228 12.3426 16.9112 12.3842 16.8889C13.2832 16.3863 14.1311 15.7983 14.916 15.133C16.629 13.6752 17.4974 12.233 17.4974 10.8473C17.4965 10.0924 17.1946 9.36872 16.6579 8.83494C16.1212 8.30115 15.3935 8.00088 14.6345 8ZM12.2487 16.3099C11.4657 15.8605 7.57259 13.4916 7.57259 10.8473C7.57322 10.2434 7.81473 9.66438 8.24411 9.23733C8.6735 8.81028 9.25569 8.57009 9.86293 8.56947C10.8306 8.56947 11.6432 9.08341 11.9839 9.91103C12.0055 9.96326 12.0422 10.0079 12.0893 10.0394C12.1365 10.0708 12.1919 10.0876 12.2487 10.0876C12.3055 10.0876 12.361 10.0708 12.4081 10.0394C12.4553 10.0079 12.492 9.96326 12.5135 9.91103C12.8542 9.08341 13.6668 8.56947 14.6345 8.56947C15.2417 8.57009 15.8239 8.81028 16.2533 9.23733C16.6827 9.66438 16.9242 10.2434 16.9248 10.8473C16.9248 13.4916 13.0317 15.8605 12.2487 16.3099Z"
        fill="#262626"
      />
    </svg>
  );
}
